// React Imports
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Redux Imports
import { beneCategories } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification.js";
import {
  resetBeneTxnMultiApprovalError,
  resetBeneTxnMultiDeniedApprovalData,
} from "../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { reimbursementTxnApproval } from "../../../redux/features/reimbursementTransaction/index.js";

// Component Imports
import Loader from "../../../components/Loader/Index";
import PaginationComponent from "../../../components/_utils/PaginationComponent/index.jsx";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import ApprovalTopNavComponent from "../../../components/_utils/CommonTopNav/ApprovalTopNav/index.jsx";
import ReimbursementTxnMultiCard from "../../../components/ReimbursementTransactionsComp/ReimbursementTxnMultiCard/index.jsx";
import ReimbursementAccountDetailsPopup from "../../../components/_utils/ReimbursementAccountDetailsPopup/index.jsx";
import ReimbursementTxnDetailsPopup from "../../../components/ReimbursementTransactionsComp/ReimbursementTxnDetailsPopup/index.jsx";

// Utils Imports
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider.js";
import useCustomSearchParams from "../../../utils/useCustomSearchParams";

const getDefaultPageSize = () =>
  window.innerWidth >= GlobalConfiguration.innerWidthLargeSize
    ? PaginationConfiguration.paginationMid
    : window.innerWidth >= GlobalConfiguration.innerWidthMidSize
      ? PaginationConfiguration.paginationExtraSmall
      : PaginationConfiguration.paginationSmall;

const ReimbursementTxnMultiApproval = () => {
  const filterRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const dropdownOptionsList = PaginationConfiguration.paginationOptions;
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptionsList[0],
  });

  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);
  const [totalAmount, setTotalAmount] = useState(
    GlobalConfiguration.lengthCheckZero,
  );
  const [allAccounts, setAllAccounts] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [selectAllCard, setselectAllCard] = useState(false);
  const [label, setlabel] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [txnlabels, settxnLabels] = useState([]);
  const [LabelSearchText, setLabelSearchText] = useState(
    searchParam.get("label")?.split(",").filter(Boolean) || [],
  );
  const [page, setPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );
  const [mainData, setMainData] = useState([]);

  const [totalCount, setTotalCount] = useState(
    GlobalConfiguration.lengthCheckOne,
  );
  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );
  const [approvedAccounts, setApprovedAccounts] = useState([]);
  const [initCategoryFilter, setInitCategoryFilter] = useState(
    searchParam.get("category") || "",
  );
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || getDefaultPageSize(),
  );
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [txnId, setTxnId] = useState(null);
  // const [datas, setDatas] = useState([]);

  const {
    // beneTxnAccountData,
    BeneTxnMultiApprovalError,
    BeneTxnMultiDeniedApprovalError,
  } = useSelector((state) => state?.beneTxnViewAccData);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const conditionVarLengthOne = GlobalConfiguration.lengthCheckOne;
  const conditionVarLengthTwenty = GlobalConfiguration?.categorymaxLength;
  const shouldShowPagination =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count > GlobalConfiguration?.lengthCheckZero &&
    allAccounts.length > GlobalConfiguration?.lengthCheckZero;

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleViewTransactionDetail = (e, context) => {
    e?.stopPropagation();
    if (context?.txn_id) {
      navigate(
        `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${context.txn_id}`,
        {
          state: {
            isViewAll: location.pathname.includes("view_all"),
          },
        },
      );
    }
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setPage(GlobalConfiguration.lengthCheckOne);
  };

  const handlePagination = (pageNum) => {
    handleSubmit("pageno", pageNum);
    setPage(pageNum);
  };

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };

  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };

  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  const SideDrawerOpen = async (id, _txnId) => {
    SetBeneTxnDetailsId(id);
    setisDrawerOpen(!isDrawerOpen);
  };

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      initCategoryFilter !== "" ||
        LabelSearchText?.length > GlobalConfiguration.lengthCheckZero,
    );
  };

  const handleClearParams = () => {
    setInitCategoryFilter("");
    setlabel([]);
    setLabelSearchText([]);
    setPage(GlobalConfiguration.lengthCheckOne);
    const keepPagesize = searchParam.get("pagesize") || dropdownOptionsList[0];
    navigate(
      {
        pathname: location.pathname,
        search: `?pageno=${GlobalConfiguration.lengthCheckOne}&pagesize=${keepPagesize}`,
      },
      { replace: true },
    );
  };

  const fetchData = async () => {
    setLoadingData(true);

    let data = [];
    switch (active) {
      case "Category": {
        const response = await dispatch(
          beneCategories({ search_string: searchUserTextDebounce }),
        );
        data =
          response?.payload?.categories?.map((itm) => ({
            id: itm.name,
            Category: itm.name,
            Description: itm?.description || "Not given",
          })) ?? [];
        break;
      }
      case "Labels":
        data =
          txnlabels
            ?.filter((itm) => itm.includes(searchUserTextDebounce))
            ?.map((val) => ({ id: val, Label: val })) ?? [];
        break;
      default:
        break;
    }
    setInputData(data);
    setLoadingData(false);
  };

  const fetchTransactions = async () => {
    setAllBeneTxnAccountsLoading(true);

    try {
      const queryParams = {
        page_no: page,
        page_size: pageSize,
        lifecycle_status: "pending",
      };
      if (LabelSearchText?.length > GlobalConfiguration.lengthCheckZero) {
        queryParams.labels = LabelSearchText;
      }
      if (initCategoryFilter !== "") {
        queryParams.category = initCategoryFilter;
      }

      const response = await dispatch(reimbursementTxnApproval(queryParams));
      const newData = response?.payload?.transactions || [];
      const formattedData =
        newData?.map((account) => ({
          ...account,
          loading: false,
          error: "false",
          message: "",
          last_updated_user_id_check: "false",
          distribution_lifecycle_status: "",
        })) || [];

      setTotalCount(
        response?.payload?.total_count ?? GlobalConfiguration.lengthCheckZero,
      );
      setMainData(response?.payload ?? {});
      setAllAccounts(formattedData);

      const approved = newData.filter(
        (account) => account.beneficiary_account_approval_status === "approved",
      );
      setApprovedAccounts((prevApproved) => [...prevApproved, ...approved]);
    } catch (error) {
      console.error("Failed to fetch transactions:", error);
      setMainData([]);
      setAllAccounts([]);
    } finally {
      setAllBeneTxnAccountsLoading(false);
    }
  };

  const handleSelectAll = (tt) => {
    const alreadySelectedCount = selectedTransactions?.length;
    const remainingSelections =
      GlobalConfiguration?.categorymaxLength - alreadySelectedCount;

    if (tt) {
      const x = approvedAccounts
        .filter((itm) => selectedTransactions.includes(itm.txn_id))
        .map((itm) => itm.txn_id);
      const y = selectedTransactions.filter((it) => !x.includes(it));
      const z = selectedSendTransactions.filter(
        (itm) => !x.includes(itm.txn_id),
      );
      setSelectedTransactions(y);
      setSelectedSendTransactions(z);
      setTotalAmount(
        z.reduce(
          (sum, account) => sum + Number(account.amount),
          GlobalConfiguration.lengthCheckZero,
        ),
      );
    } else if (
      LabelSearchText?.length === GlobalConfiguration.lengthCheckZero &&
      remainingSelections === GlobalConfiguration.lengthCheckZero
    ) {
      setSelectedTransactions([]);
      setSelectedSendTransactions([]);
      setTotalAmount(GlobalConfiguration.lengthCheckZero);
    } else if (remainingSelections > GlobalConfiguration.lengthCheckZero) {
      const newSelections = allAccounts
        .filter(
          (account) =>
            account.beneficiary_account_approval_status === "approved" &&
            !selectedTransactions.includes(account.txn_id),
        )
        .slice(GlobalConfiguration.lengthCheckZero, remainingSelections)
        .map((account) => account.txn_id);

      const newSelectionsSend = allAccounts
        .filter(
          (account) =>
            account.beneficiary_account_approval_status === "approved" &&
            !selectedTransactions.includes(account.txn_id),
        )
        .slice(GlobalConfiguration.lengthCheckZero, remainingSelections)
        .map((account) => account);

      setSelectedTransactions((prevSelected) => [
        ...prevSelected,
        ...newSelections,
      ]);
      setSelectedSendTransactions((prevSelected) => [
        ...prevSelected,
        ...newSelectionsSend,
      ]);
      const newAmounts = allAccounts
        .filter((account) => newSelections.includes(account.txn_id))
        .reduce(
          (sum, account) => sum + Number(account.amount),
          GlobalConfiguration.lengthCheckZero,
        );
      setTotalAmount((prevAmount) => prevAmount + newAmounts);
    } else {
      const x = approvedAccounts
        .filter((itm) => selectedTransactions.includes(itm.txn_id))
        .map((itm) => itm.txn_id);
      const y = selectedTransactions.filter((it) => !x.includes(it));
      const z = selectedSendTransactions.filter(
        (itm) => !x.includes(itm.txn_id),
      );
      setSelectedTransactions(y);
      setSelectedSendTransactions(z);
      setTotalAmount(
        z.reduce(
          (sum, account) => sum + Number(account.amount),
          GlobalConfiguration.lengthCheckZero,
        ),
      );
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active, searchUserTextDebounce]);

  useEffect(() => {
    dispatch(enableSwitcher());
    const onMount = () => {
      const availableLabels = sessionStorage?.getItem("AvailableLabelsTxnRem");
      if (availableLabels) {
        try {
          const parsedLabels = JSON?.parse(availableLabels);
          settxnLabels(parsedLabels || []);
        } catch (error) {
          console.error("Error parsing labels from sessionStorage:", error);
          settxnLabels([]);
        }
      }
      // fetchTransactions();
    };
    onMount();
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    dispatch(resetBeneTxnMultiApprovalError());
    dispatch(resetBeneTxnMultiDeniedApprovalData());
  }, [BeneTxnMultiApprovalError, BeneTxnMultiDeniedApprovalError]);

  useEffect(() => {
    const availableLabels = sessionStorage?.getItem("AvailableLabelsTxn");
    if (availableLabels) {
      try {
        const parsedLabels = JSON?.parse(availableLabels);
        settxnLabels(parsedLabels || []);
      } catch (error) {
        console.error("Error parsing labels from sessionStorage:", error);
        settxnLabels([]);
      }
    }
    // fetchTransactions();
  }, [markerData]);

  useEffect(() => {
    fetchTransactions();
  }, [dispatch, page, pageSize, initCategoryFilter, LabelSearchText]);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);
    setPage((prevPage) => {
      if (newTotalPages === GlobalConfiguration.lengthCheckZero) {
        return GlobalConfiguration.lengthCheckOne;
      }
      if (prevPage > newTotalPages) {
        return newTotalPages;
      }
      return prevPage;
    });
  }, [totalCount, pageSize]);

  useEffect(() => {
    const handlefilter = (e) => {
      if (filterRef.current && filterRef.current.contains(e.target)) {
        setShowSearchBar(false);
      }
    };
    document.addEventListener("click", handlefilter);
    return () => document.removeEventListener("click", handlefilter);
  }, [filterRef]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [initCategoryFilter, LabelSearchText]);

  return (
    <>
      {showTxnDetailPop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ReimbursementTxnDetailsPopup
            closePopup={closeBeneTxnDetailModal}
            account_txn_id={txnId}
            type={"bene_txn_detail_modal"}
            TransactionHeader={"Reimbursement transaction details"}
          />
        </div>
      )}
      {isDrawerOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <ReimbursementAccountDetailsPopup
            reimburse_account_id={BeneTxnDetailsId}
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            type={"reimburseacc_details"}
          />
        </div>
      )}

      <div
        className={` bg-primary-bg flex flex-col h-screen relative overflow-hidden`}
        style={{
          background: showInnerSearchBar ? "var(--bg-PopUp-BackDrop)" : "",
        }}
      >
        <div className="w-width-full h-height-full">
          <div className="w-width-full h-height-full relative z-z-index-content flex flex-col overflow-y-hidden overflow-x-hidden">
            <div className="w-width-full h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav flex-shrink-0"></div>
            <>
              <ApprovalTopNavComponent
                ispagination={shouldShowPagination}
                handleBack={() => navigate(GlobalConfiguration?.navigate_back)}
                isSelectionView={true}
                topNavHeader={totalAmount}
                topNavSubText={"Total amount"}
                selectionText={`Transactions selected : ${selectedTransactions?.length}`}
                selectionBtnProps={
                  !shouldShowPagination
                    ? undefined
                    : {
                        btnText: "Select up to 20",
                        btnType: "button",
                        enabledBgColor:
                          selectedTransactions?.length <
                            GlobalConfiguration?.categorymaxLength &&
                          approvedAccounts.length !==
                            GlobalConfiguration?.lengthCheckZero &&
                          approvedAccounts.every((itm) =>
                            selectedTransactions.includes(itm.txn_id),
                          )
                            ? "var(--positive-bg)"
                            : selectedTransactions?.length ===
                                GlobalConfiguration?.categorymaxLength
                              ? "var(--positive-bg)"
                              : "var(--primary-nav-act)",
                        hoverOption:
                          selectedTransactions?.length <
                            GlobalConfiguration?.categorymaxLength &&
                          approvedAccounts.length !==
                            GlobalConfiguration?.lengthCheckZero &&
                          approvedAccounts.every((itm) =>
                            selectedTransactions.includes(itm.txn_id),
                          )
                            ? "black"
                            : selectedTransactions?.length ===
                                conditionVarLengthTwenty
                              ? "black"
                              : "white",
                        enabledTextColor: "var(--text-primary)",
                        icon:
                          selectedTransactions?.length <
                            GlobalConfiguration?.categorymaxLength &&
                          approvedAccounts.length !==
                            GlobalConfiguration?.lengthCheckZero &&
                          approvedAccounts.every((itm) =>
                            selectedTransactions.includes(itm.txn_id),
                          )
                            ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                            : selectedTransactions?.length ===
                                conditionVarLengthTwenty
                              ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                              : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg",
                        handleFunction: () => {
                          setselectAllCard(
                            approvedAccounts.every((itm) =>
                              selectedTransactions.includes(itm.txn_id),
                            )
                              ? true
                              : selectAllCard
                                ? false
                                : true,
                          );
                          handleSelectAll(
                            approvedAccounts.every((itm) =>
                              selectedTransactions.includes(itm.txn_id),
                            ),
                          );
                        },
                      }
                }
                topNavCtaBtn2Props={{
                  btnText: "Proceed",
                  btnType: "button",
                  enabledBgColor: "var(--text-primary)",
                  inActiveVariantNeeded: true,
                  handleFunction: () => {
                    if (selectedTransactions?.length >= conditionVarLengthOne) {
                      const selectedData = {
                        selectedSendTransactions,
                        selectedTransactions,
                        timestamp: Date.now(),
                      };
                      sessionStorage.setItem(
                        "selectedReimbursementTxnData",
                        JSON.stringify(selectedData),
                      );
                      navigate(
                        "/reimbursement_transaction_dashboard/reimbursement_transaction_multi_approval/multi_approval",
                      );
                    }
                  },
                  enabledTextColor: "var(--primary-bg)",
                  isDisabled: !selectedTransactions?.length,
                  disabledBgColor: "var(--text-disabled)",
                  disabledTextColor: "var(--text-primary)",
                }}
                isToggleNeeded={true}
                toggleProps={{
                  state: false,
                  isDisabled: false,
                  title: "Single Approval",
                  handleClick: () =>
                    navigate(
                      "/reimbursement_transaction_dashboard/reimbursement_transaction_single_approval",
                    ),
                }}
                iconComponentArray={[
                  {
                    icon: "https://q2pay.in/new_assets/common/view_all/search_white.svg",
                    title: "Search",
                    hoverOption: "white",
                    isLoading: false,
                    isDisabled: allBeneTxnAccountsLoading,
                    enabledBgColor: initCategoryFilter
                      ? "var(--text-primary)"
                      : "var(--primary-bg)",
                    handleFunction: () => setShowSearchBar((prev) => !prev),
                  },
                ]}
                filteredSearchProps={{
                  setShowInnerSearchBar,
                  showSearchBar,
                  isSearchDisabled: allBeneTxnAccountsLoading,
                  onSearchInput: handleSearch,
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: "Search reimbursement transaction",
                  filterPlaceholder: "reimbursement name",
                  filterItems: [
                    {
                      name: "Category",
                      valueType: "string",
                      short_name: "Cat",
                      isMulti: false,
                      value: initCategoryFilter,
                      setValue: (val) => {
                        setPage(GlobalConfiguration.lengthCheckOne);
                        handleSubmit("category", val);
                        setInitCategoryFilter(val);
                      },
                      isDropdown: true,
                      isDisabled: allBeneTxnAccountsLoading,
                    },
                    {
                      name: "Labels",
                      valueType: "string",
                      short_name: "Lab",
                      isMulti: true,
                      value: label,
                      setValue: (val) => {
                        setPage(GlobalConfiguration.lengthCheckOne);
                        handleSubmit(
                          "label",
                          Array.isArray(val) ? val.join(",") : val,
                        );
                        setlabel(val);
                        setLabelSearchText(val);
                      },
                      isDropdown: true,
                      isDisabled: allBeneTxnAccountsLoading,
                    },
                  ],
                  isSearchClearAllDisabled: !(
                    initCategoryFilter?.length || LabelSearchText?.length
                  ),
                  inputData,
                  active,
                  setActive,
                  loading: loadingData,
                  setLoading: setLoadingData,
                  isShowFilter: false,
                }}
              />
            </>

            <div
              ref={filterRef}
              className={`${showInnerSearchBar ? " flex-1 bg-PopUp-BackDrop opacity-dark-opacity" : "flex flex-col flex-1 overflow-y-auto"} ${
                allAccounts?.length === GlobalConfiguration.lengthCheckZero ||
                allBeneTxnAccountsLoading
                  ? "pb-bottom-base"
                  : "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
              } `}
            >
              {showInnerSearchBar && (
                <div
                  className={
                    "absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header pointer-events-none"
                  }
                ></div>
              )}
              <div
                className="w-width-full overflow-y-auto h-[-webkit-fill-available] z-z-index-content"
                style={{ overflow: showInnerSearchBar ? "hidden" : "auto" }}
              >
                {allBeneTxnAccountsLoading ? (
                  <div
                    style={{
                      opacity: showInnerSearchBar
                        ? "var(--opcacity_none)"
                        : "var(--base-opacity)",
                    }}
                    className="loader-container m-auto justify-center items-center flex h-height-full"
                  >
                    <Loader />
                  </div>
                ) : !allAccounts?.length ? (
                  <div
                    className="int-txn-mutli-no-account-found"
                    style={{
                      opacity: showInnerSearchBar
                        ? "var(--light-opacity)"
                        : "var(--base-opacity)",
                    }}
                  >
                    <div className="flex justify-center items-center">
                      <img
                        src={
                          isFilterApplied
                            ? "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                            : "https://q2pay.in/new_assets/graphics/no_data/no_pending_transaction.svg"
                        }
                        className="px-padding-sm w-graphic-width-md h-graphic-square-height-md int_txn_img"
                        alt="NoData"
                      />
                    </div>
                    <div className="int-txn-mutli-left-text-content-no-account !mt-margin-sm">
                      {isFilterApplied ? (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            No data found.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Clear Parameters"
                              handleFunction={handleClearParams}
                              enabledBgColor="var(--primary-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            There are no more transactions that require <br />
                            your approval.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Reimbursement transaction dashboard"
                              handleFunction={() =>
                                navigate("/reimbursement_transaction_dashboard")
                              }
                              enabledBgColor="var(--primary-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${showInnerSearchBar ? "pointer-events-none" : "flex flex-col items-center justify-center mx-auto bg-primary-bg"}`}
                  >
                    <ReimbursementTxnMultiCard
                      filterOpen={showInnerSearchBar}
                      setAllAccounts={setAllAccounts}
                      data={allAccounts}
                      selectedTransactions={selectedTransactions}
                      setSelectedTransactions={setSelectedTransactions}
                      totalAmount={totalAmount}
                      setselectAllCard={setselectAllCard}
                      setTotalAmount={setTotalAmount}
                      selectedSendTransactions={selectedSendTransactions}
                      setSelectedSendTransactions={setSelectedSendTransactions}
                      SideDrawerOpen={SideDrawerOpen}
                      openBeneTxnDetailModal={openBeneTxnDetailModal}
                      setTxnId={setTxnId}
                      // setDatas={setDatas}
                      onViewTransactionDetail={handleViewTransactionDetail}
                    />
                  </div>
                )}
              </div>
            </div>

            <div
              className={`flex flex-col absolute bottom-bottom-base w-full ${showInnerSearchBar ? "opacity-light-opacity pointer-events-none z-z-index-content bg-PopUp-BackDrop" : "opacity-base-opacity z-z-index-modal"}`}
            >
              {shouldShowPagination ? (
                <div
                  className={`${
                    showInnerSearchBar &&
                    "opacity-light-opacity bg-PopUp-BackDrop h-full w-full"
                  }`}
                >
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptionsList}
                    handlePagination={handlePagination}
                    currentPage={page}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReimbursementTxnMultiApproval;
